import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/Loader";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <Loader label="Warming up the kitchen…" />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};
